// Single source of truth for the "Free Documents" weekend promo so the
// hero slide, banners and document cards all stay in sync, and the promo
// auto-hides once it's over (no stale "this weekend" copy lingering).
export const WEEKEND_OFFER = {
  label: "Anniversary Offer",
  dates: "26 Jun – 5 Jul",
  // Inclusive window. Update these two when running the next promo.
  start: "2026-06-26",
  end: "2026-07-05",
};

// True from now through the end of the offer day, false afterwards, so the
// promo shows in the run-up and during the weekend, then quietly retires.
export function isWeekendOfferActive() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const end = new Date(`${WEEKEND_OFFER.end}T23:59:59`);
  return today.getTime() <= end.getTime();
}
